export enum BlockType {
  SectionHeader = 'section-header',
  Paragraph = 'paragraph',
  ImageAndParagraphs = 'image-and-paragraphs',
  SectionContainer = 'container',
  HeaderParagraphs = 'header-paragraphs',
  ActionLink = 'action-link',
  Image = 'image',
  Row = 'row',
  PvpBuildExample = 'pvp-build-example',
  IndexImageGrid = 'index-image-grid',
  YoutubeGrid = 'youtube-grid',
  YoutubeAutoplay = 'youtube-autoplay'
}

export enum ParagraphBlockVariant {
  InfoBlock = 'info-block',
  BlueBlock = 'blue-block',
  Default = 'default'
}

export enum SectionHeaderVariant {
  Large = 'large',
  Default = 'default'
}
